import {
  HorizontalSectionInfo,
  VerticalSectionInfo,
} from '../../core/types/ui/placement';
import { Size } from '../../core/types/ui/size';
import { BottomSheetSection, TopSheetSection } from '../../sheet/types';
import { WindowSizes } from '../../windows/constants/windowSizes';
import {
  BottomSection,
  LeftSection,
  RightSection,
  SectionsState,
  TopSection,
} from '../types';

export const getMaxSizeAndPos = (sections: SectionsState) => {
  const width = calculateSectionWidth(sections);
  const height = calculateSectionHeight(sections);

  const y = calculateSectionHeightHelper(sections.topSection);
  const x = 0;

  return {
    width: sections.fullScreen ? window.innerWidth : window.innerWidth - width,
    height: sections.fullScreen
      ? window.innerHeight
      : window.innerHeight - height,
    y,
    x,
  };
};

export const getTopAndBottomSectionSum = (sections: SectionsState) => ({
  topSectionSum: calculateSectionHeightHelper(sections.topSection),
  bottomSectionSum: calculateSectionHeightHelper(sections.bottomSection),
});
// export const getWindowMaxLimits = (
//   sections: SectionsState,
//   masterWinSize: Size
// ) => {
//   const topLimit = calculateSectionHeightHelper(sections.topSection);
//   const bottomSum = calculateSectionHeightHelper(sections.bottomSection);
//   const rightSum = calculateSectionWidthHelper(sections.rightSection);

//   return {
//     topLimit: topLimit,
//     rightLimit: Math.floor(masterWinSize.width - WindowSizes.minWidth - rightSum),
//     bottomLimit: Math.floor(masterWinSize.height - WindowSizes.minHeight - bottomSum),
//   };
// };

export const calculateSectionWidthHelper = (
  section: LeftSection | RightSection
): number => {
  return Object.values(section).reduce((width, subsection) => {
    if (subsection.isVisible && subsection.width) {
      return width + subsection.width;
    }
    return width;
  }, 0);
};

const calculateSectionWidth = (sections: SectionsState): number => {
  let width = 0;
  width += calculateSectionWidthHelper(sections.leftSection);
  width += calculateSectionWidthHelper(sections.rightSection);

  return width;
};

export const getSectionHeight = (section?: HorizontalSectionInfo) =>
  section?.isVisible ? section?.height : 0;

export const getSectionWidth = (section?: VerticalSectionInfo) =>
  section?.isVisible ? section?.width : 0;

export const calculateSectionHeightHelper = (
  section: TopSection | TopSheetSection | BottomSection | BottomSheetSection
): number => {
  return Object.values(section).reduce((height, subsection) => {
    if (subsection.isVisible && subsection.height) {
      return height + subsection.height;
    }
    return height;
  }, 0);
};

const calculateSectionHeight = (sections: SectionsState): number => {
  let height = 0;
  height += calculateSectionHeightHelper(sections.topSection);
  height += calculateSectionHeightHelper(sections.bottomSection);

  return height;
};
